<template>
  <div class="event-wrapper">
    <a
      href="https://www.eventbrite.com.au/e/paradox-festival-tickets-1251086566599?aff=oddtdtcreator&fbclid=PAZXh0bgNhZW0CMTEAAaeKKc1ZiLu5-kZckqi33v1QDomOSJ-HUPH44YU-_dhrT5Jzssu4hH55vZbSnA_aem_ehxFOpTXnAoQGxg2DBh74g"
      target="_blank"
      style="text-decoration: none"
      class="hover-group"
    >
      <img
        style="max-height: 50vh"
        class="paradox img-fluid rounded"
        src="/images/events/PARADOX.jpg"
      />
      <div class="text-white moderustic-font pt-5 text-center">
        <div class="ticket-section d-inline-block">
          <h1 class="title-text" style="letter-spacing: 8px">PARADOX</h1>
          <h3 class="ticket-text">GET TICKETS NOW</h3>
        </div>
      </div>
    </a>
  </div>
</template>

<script>
export default {
  name: 'EventBlock',
};
</script>

<style>
@import url('https://fonts.googleapis.com/css2?family=Moderustic:wght@300..800&display=swap');
.moderustic-font {
  font-family: 'Moderustic', sans-serif;
  font-optical-sizing: auto;
  font-weight: 500;
  font-style: normal;
}

.event-wrapper {
  display: inline-block;
}

.paradox {
  box-shadow: #ff6400 0px 7px 29px 0px;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.hover-group {
  display: block;
  transition: transform 0.3s ease;
}

.hover-group:hover {
  transform: scale(1.02);
}

.hover-group:hover .paradox {
  box-shadow: #ff6400 0px 10px 35px 0px;
}

.ticket-section {
  cursor: pointer;
}

.title-text {
  transition: all 0.3s ease;
  margin-bottom: 1rem;
}

.ticket-text {
  font-size: smaller;
  position: relative;
  display: inline-block;
  transition: all 0.3s ease;
  margin: 0;
}

.ticket-text::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 2px;
  bottom: -4px;
  left: 0;
  background: linear-gradient(90deg, #ff6400, #4682b4);
  transform: scaleX(0);
  transition: transform 0.3s ease;
}

.ticket-section:hover .title-text,
.ticket-section:hover .ticket-text {
  text-shadow: 0 0 8px rgba(255, 100, 0, 0.6);
  letter-spacing: 10px;
}

.ticket-section:hover .ticket-text::after {
  transform: scaleX(1);
}
</style>
